import Client from './KomodoClient';

// komodo settings menu tree: rows of gy_navigation pruned server-side by feature flags.
const list = (deptCode, userCode) =>
	Client.post('/api/navigation/query-list', {
		AppId: 'scm',
		DeptCode: deptCode,
		UserCode: userCode,
	});

export default { list };
